import { MessagingChannelPurpose } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const channelPurposeMessages = defineMessages({
  conversational: {
    defaultMessage: 'Conversational',
    description: 'channel purpose name',
  },
  transactional: {
    defaultMessage: 'Transactional',
    description: 'channel purpose name',
  },
})

export function translateChannelPurpose(intl: IntlShape, purpose: MessagingChannelPurpose): string {
  switch (purpose) {
    case MessagingChannelPurpose.CONVERSATIONAL:
      return intl.formatMessage(channelPurposeMessages.conversational)
    case MessagingChannelPurpose.TRANSACTIONAL:
      return intl.formatMessage(channelPurposeMessages.transactional)
  }
}
